<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <div class="date-picker-v2">
          <el-date-picker
            class="query-date-picker"
            v-model="formInline.queryYear"
            type="monthrange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :range-separator="$t('rangeSeparator')"
            start-placeholder="开始年份"
            end-placeholder="结束年份"
            @change="search"
          />
        </div>
        <div class="input-v2">
          <el-input v-model="formInline.batchName" placeholder="批次名称" suffix-icon="el-icon-search" clearable @keyup.native.enter="search"></el-input>
        </div>
        <div class="input-v2 ml16">
          <el-input v-model="formInline.id" placeholder="导入批次编码" suffix-icon="el-icon-search" clearable @keyup.native.enter="search"></el-input>
        </div>
        <div class="input-v2 ml16">
          <el-button type="primary" class="button-v2" @click="_getLoadBatch">查询</el-button>
        </div>
      </div>
      <div class="title-right">
        <el-button class="button-v2" type="primary" @click="add">创建批次</el-button>
      </div>
    </div>
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="customList"
        :data="tableData"
      >
        <template #operation="{ row }">
          <div class="flex center">
            <span class="text-button" v-if="row.isSubmit==='10020002'" @click="submitRow(row)">提交</span>&nbsp;&nbsp;&nbsp;
            <span class="text-button" @click="handleClick(row)">详情</span>&nbsp;&nbsp;&nbsp;
            <span class="text-button" v-if="row.isSubmit==='10020002'" @click="deleteRow(row)">删除</span>
            <span class="text-button" v-if="row.isSubmit==='10020001' && (form.userId==='1374773339758788608' || form.userId==='1405913319067353088') &&row.wageMonth>=previousMonthFormatted()" @click="returnRow(row)">退回</span>
          </div>
        </template>
      </air-table>
      <bsp-pagination
        :pager-config.sync="formInline"
        :current-page.sync="formInline.page"
        :page-size.sync="formInline.limit"
        @page-change="handleCurrentChange"
        @page-size-change="handleSizeChange"
        show-page-size
      />
    </div>
    <!-- 创建批次弹框 -->
    <el-dialog
      class="modal-v2 has-padding"
      ref="cusPaysetDialog"
      v-dialogDrag title="创建批次"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="addUpload"
      append-to-body
      width="600px"
    >
      <el-form class="form-v2 upload-modal" ref="form" :model="form" label-width="80px">
        <el-form-item label="年度">
          <el-date-picker
            class="date-picker-v2 has-icon w100"
            v-model="form.year"
            type="year"
            format="yyyy"
            value-format="yyyy">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="月份">
          <el-select placeholder="月份" v-model="form.month" class="select-v2">
            <el-option
              v-for="item in mouth"
              :key="item"
              :label="item+'月'"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件上传">
          <el-upload
            v-loading="loading"
            class="text-left"
            name="file"
            ref="upload"
            action="#"
            :before-upload="beforeFileUpload"
            :show-file-list="true"
            :http-request="fileUploadSuccess"
            :on-remove="handleRemove"
            limit=1
            drag
          >
            <div v-if="!uploadFlag">
              <i class="el-icon-upload"/>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </div>
            <el-button class="uploadFlag" type="success" icon="el-icon-check" circle v-else></el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="downloadTemplate">下载模板</el-button>
        <div class="flex acenter">
          <el-button class="button-v2" plain @click="close()">取消</el-button>
          <el-button type="primary" class="button-v2" @click="_importExcel()">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import {downloadTmpExcel,importExcel,getLoadBatch,deleteBatch,submitBatch,returnBatch} from "@/api/merit/ruichen.js"
  export default {
    computed: {
      ...mapGetters([
        'userInfo'
      ])
  },
  created(){
    this.form.cusId = this.userInfo.cusId
    this.form.cusName = this.userInfo.cusName
    this.form.branchId = this.userInfo.branchId
    this.form.userId = this.userInfo.userId
    this.form.userName = this.userInfo.loginName
    this._getLoadBatch()
  },
  data() {
    return {
      formInline:{
        queryYear:[],
        batchName:'',
        id:'',
        limit: 10,
        page: 1,
        total: 0,
      },
      form:{
        cusId:'',
        branchId:'',
        year:this.$day().format('YYYY'),
        month:this.$day().format('MM'),
        userId:'',
        userName:''
      },
      mouth:[...'123456789','10','11','12'],
      loading: false,
      importUrl: '/api/wage/meritManage/importExcel',
      addUpload:false,
      tableData: [],
      file: null,
      uploadFlag:false,
      customList: [
      {
        title: "月度",
        field: "wageMonth",
      },
      {
        title: "批次名称",
        field: "batchName"
      },
      {
        title: "门店",
        field: "cusName"
      },
      {
        title: "导入时间",
        field: "bizCreateTime",
      },
      {
        title: "导入批次编码",
        field: "id",
      }
    ]
  };
  },
  methods: {
    add() {
      this.addUpload = true;
    },
    close(){
      this.addUpload = false;
      this.file=null;
      this.uploadFlag=false;
      this.form.month = this.$day().format('MM');
      this.form.year = this.$day().format('YYYY');
      this.$refs['upload'].clearFiles();
      
    },
    handleClick(row) {
      this.$router.push('/merit/debtDetails?batchId='+row.id+'&importDate='+row.wageMonth);
    },
    handleSizeChange() {
      this._getLoadBatch(this.formInline)
    },
    handleCurrentChange() {
      this._getLoadBatch(this.formInline)
    },
    // 删除
    deleteRow(row) {
      this.$confirm('您确定要删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id:row.id//批次id
        }
        deleteBatch(params).then(res=>{
          this._getLoadBatch()
          that.$message.success('删除成功!')
        })
      
      }).catch(() => {
      });
    },
    // 提交
    submitRow(row) {
      this.$confirm('您确定要提交该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      let params = {
        batchIds:row.id//批次id
      }
      submitBatch(params).then(res=>{
        this._getLoadBatch()
        that.$message.success('提交成功!')
      })
      }).catch(() => {
      });
    },
    returnRow(row) {
      this.$confirm('您确定要退回该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      let params = {
        batchIds:row.id//批次id
      }
      returnBatch(params).then(res=>{
        this._getLoadBatch()
        that.$message.success('退回成功!')
      })
      }).catch(() => {
      });
    },
    previousMonthFormatted() {
      const lastMonth = this.$day().subtract(1, 'month').format('YYYY-MM');
      return lastMonth;
    },
    downloadTemplate() {
      downloadTmpExcel(this.form.cusId).then(res => {
        this.$downloadFile(res)
      })
    },
    fileUploadSuccess(response, file, fileList) {
      this.file = response.file;
      this.$set(this, "loading", false);
      this.uploadFlag = true
      
    },
    handleRemove(file, fileList) {
      this.uploadFlag=false
    },
    fileUploadError(err, file, fileList) {
      this.$set(this, "loading", false);
      this.$message.error( "导入失败!" );
    },
    beforeFileUpload(file) {
      this.$set(this, "loading", true);
      let isExcel = true;
      const isxls = file.type === "application/vnd.ms-excel";
      const isxlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const isLtM = file.size / 1024 / 1024 < 10;
      
      if (!isxls && !isxlsx) {
        isExcel = false;
        this.$message.error("导入文件只能是 xls,xlsx 格式!");
        this.$set(this, "loading", false);
      }
      if (!isLtM) {
        this.$message.error("导入文件大小不能超过 10MB!");
        this.$set(this, "loading", false);
      }
      return isExcel && isLtM;
    },
    // 查询
    search(){
      // this._getCostCenterComparisonColumns(this.formInline)
    },
    // 初始化数据
    _getLoadBatch() {
      let params = {
        pageNum:'1',
        page: this.formInline.page,
        limit: this.formInline.limit,
        ... this.formInline
      }
      getLoadBatch(params).then(res=>{
        this.tableData = res.data.records
        this.formInline.total = parseInt(res.data.total)
      })
    },
    // 创建批次
    _importExcel() {
      const form = new FormData();
      form.append("file", this.file);
      const params = {
        param: JSON.stringify(this.form)
      }
      importExcel(form, params).then(res=>{
        if(res.data.code == 0) {
        this.addUpload = false;
        this._getLoadBatch()
      }
    })
    }
  }
  };
</script>
<style lang="scss" scoped>
  .uploadFlag{
    font-size: 57px !important;
    background: #67C23A !important;
    margin: 52px 0 16px !important;
    line-height: 50px !important;
  }
</style>
